// Module
var code = "<mn-number-container type=\"float\" empty=\"true\" ng-model-options=\"{updateOn: 'blur'}\"></mn-number-container>";
// Exports
module.exports = code;